/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { AssociatedCompanyDocumentApprovalFilterViewModel } from "../types/AssociatedCompanyDocumentApprovalFilterViewModel.ts";

export const associatedCompanyDocumentApprovalFilterViewModelSchema = z.object({
  classStudents: z
    .array(z.number().int())
    .describe("IDs das turmas. Opcional (ao menos um filtro é obrigatório).")
    .nullish(),
  personId: z
    .number()
    .int()
    .describe(
      "ID do aluno; quando informado, os filtros de status não se aplicam (comportamento do legado). Opcional.",
    )
    .nullish(),
  enrollmentStatus: z
    .array(z.number().int())
    .describe(
      "Status da matrícula para filtro. Opcional. Enum EEnrollmentStatus: `1` = PaymentSelection, `2` = PaymentPending, `3` = ApprovalPending, `4` = Approved, `5` = Activating, `6` = Active, `7` = Transferred, `8` = TransferredInRegistration, `9` = Canceled, `10` = CanceledInRegistration, `11` = Rejected, `12` = FinishedWithPendencies, `13` = Finished, `14` = FinishedWithMonograph, `15` = FinishedWithCertificate, `16` = Blocked.",
    )
    .nullish(),
  documentationStatus: z
    .array(z.number().int())
    .describe(
      "Status geral da documentação da conveniada para filtro. Opcional. Enum EDocumentationStatus: `0` = Pending, `1` = Approved, `2` = Rejected, `3` = ApprovedTemporary.",
    )
    .nullish(),
  associatedCompanyId: z
    .number()
    .int()
    .describe("ID da empresa conveniada. Opcional.")
    .nullish(),
  page: z.optional(
    z
      .number()
      .int()
      .default(1)
      .describe("Página da listagem (10 itens por página). Mínimo 1."),
  ),
}) as unknown as ToZod<AssociatedCompanyDocumentApprovalFilterViewModel>;
